function ClockOutline({width = 18, height = 18}: {width?: number; height?: number}) {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
            <path
                d="M9 4.49964V9L12.0002 10.5001M16.5006 9C16.5006 13.1425 13.1425 16.5006 9 16.5006C4.85753 16.5006 1.4994 13.1425 1.4994 9C1.4994 4.85753 4.85753 1.4994 9 1.4994C13.1425 1.4994 16.5006 4.85753 16.5006 9Z"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default ClockOutline;
